import React, { useEffect, useState } from "react";
import { Button, Form, InputNumber, Spin } from "antd";
import { t } from "i18next";
import { getNSSF, updateSeniorityAndSeverancePay } from "services/nssf";
import { Util } from 'common/util';


export default function Index() {
   const [loading, setLoading] = useState(false);
   const [buttonLoading, setButtonLoading] = useState(false);
   const [form] = Form.useForm();

   useEffect(() => {
      setLoading(true);
      getNSSF().then((response) => {
         const data = response.data.data;
         if (data) {
            form.setFieldsValue({
               seniority: data.seniority,
               severancePay: data.severancePay
            });
         }
      })
         .finally(() => setLoading(false));
      // eslint-disable-next-line
   }, []);

   const handleOnFocus = (event) => {
      event.target.select();
   }

   const onFinish = (values) => {
      setButtonLoading(true);
      updateSeniorityAndSeverancePay(values).then(() => {
         Util.getInstance().sweetAlertMessage(t("text_success_update"), "success");
      })
         .finally(() => setButtonLoading(false));
   };

   return (
      loading ?
         <Spin
            spinning={loading}
            style={{
               display: "flex",
               justifyContent: "center",
               height: "84vh",
               alignItems: "center",
            }}
         />
         :
         <>
            <div id="title">
               <span>{"Seniority & Severance Pay"}</span>
            </div>

            <Form form={form} onFinish={onFinish}>
               <Form.Item
                  name="seniority"
                  label={"Taxable Seniority"}
                  style={{ width: 275, marginTop: 15, marginLeft: 0 }}
               >
                  <InputNumber
                     placeholder={"Taxable Seniority"}
                     addonAfter="៛"
                     onFocus={handleOnFocus}
                  />
               </Form.Item>
               <Form.Item
                  name="severancePay"
                  label={"SeverancePay"}
                  style={{ width: 275, marginLeft: 0 }}

               >
                  <InputNumber
                     placeholder={"SeverancePay"}
                     addonAfter="%"
                     onFocus={handleOnFocus}
                     max={100}
                  />
               </Form.Item>
               <div className="btn-approval">
                  <Button type="primary" htmlType="submit" loading={buttonLoading}>
                     {t("text_save")}
                  </Button>
               </div>
            </Form>
         </>
   );
}
